<div>
  <header [class.header-seamless]="seamless()" ngClass.gt-xs="header-lg" ngClass.xs="header">
    <div ngClass.xs="wide-full-section">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <a fxHide fxShow.gt-xs routerLink="/">
          <img alt="체크팀" ngClass.gt-xs="logo-img" ngClass.xs="logo-xs-img"
               src="/assets/img/bi/bi-brilliant.svg" src.gt-xs="/assets/img/bi/bi-text.svg">
        </a>

        <a aria-label="체크팀 홈" class="mobile-brand" fxHide.gt-xs fxShow routerLink="/">
          <img alt="체크팀" src="/assets/img/bi/bi-text.svg">
        </a>


        <div fxLayout="row" fxLayoutAlign.gt-xs="end center" fxLayoutGap.gt-xs="12px" fxLayoutGap.xs="10px">
          @if (!mobile()) {
            <div fxLayout="row" fxLayoutGap="10px" class="p-t-5">

              <button [matMenuTriggerFor]="myHouse" mat-button>
                <span class="c-header-lg">등기변경 알림</span>
                <span aria-hidden="true" class="material-symbols-outlined c-gray mat-icon-size-25">arrow_drop_down</span>
              </button>
              <mat-menu #myHouse="matMenu" xPosition="before">
                <button mat-menu-item routerLink="/house/list">등기변경 리스트</button>
                <button [queryParams]="{type: 'MY_HOUSE'}" mat-menu-item routerLink="/house/register">등기변경 알림 신청
                </button>
                <button mat-menu-item routerLink="/house/batch">서비스 일괄 신청</button>
                <button mat-menu-item routerLink="/house/extends">서비스 일괄 연장</button>
                <button mat-menu-item routerLink="/coupon">쿠폰 구입</button>
                <button mat-menu-item routerLink="/info/my-house">서비스 안내</button>
              </mat-menu>

              @if (devMode) {
                <button [matMenuTriggerFor]="ownerMonitoring" mat-button>
                  <span class="c-header-lg">소유자 모니터링</span>
                  <span aria-hidden="true" class="material-symbols-outlined c-gray mat-icon-size-25">arrow_drop_down</span>
                </button>
                <mat-menu #ownerMonitoring="matMenu" xPosition="before">
                  <button mat-menu-item routerLink="/owner-monitoring">소유자 변경 모니터링</button>
                  <button mat-menu-item routerLink="/info/owner-monitoring">서비스 소개</button>
                </mat-menu>
              }

              <button [matMenuTriggerFor]="analysis" mat-button fxLayoutAlign="start center">
                <span class="c-header-lg">권리 분석</span>
                <span aria-hidden="true" class="material-symbols-outlined mat-icon-size-25">arrow_drop_down</span>
              </button>
              <mat-menu #analysis="matMenu" xPosition="before">
                <!-- 일반 메뉴 아이템 -->
                <button mat-menu-item routerLink="/analysis/list">권리분석 보고서</button>
                <button mat-menu-item routerLink="/analysis">신규 권리분석</button>
                <button mat-menu-item routerLink="/analysis/info">권리분석 소개</button>
              </mat-menu>


              <button [matMenuTriggerFor]="scorer" class="c-header-lg m-t-m2" mat-button>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="c-header-lg p-r-4"><span class="f-w-850">AI</span> 부동산 시세</div>
                    <div class="accent-bg-chip-xxs bg-gray">베타</div>
                    <div aria-hidden="true" class="material-symbols-outlined c-gray mat-icon-size-25">arrow_drop_down</div>
                  </div>

                </div>
              </button>
              <mat-menu #scorer="matMenu" xPosition="before">
                <button mat-menu-item routerLink="/scorer">시세 검색</button>
                <button mat-menu-item routerLink="/report/monthly">부동산 리포트</button>
                <button mat-menu-item routerLink="/info/scorer">AI 시세검색 소개</button>
              </mat-menu>

              <button class="m-t-m2 c-header-lg" mat-button routerLink="/info/pricing">
                <span>이용금액</span>
              </button>

              <button [matMenuTriggerFor]="openHouse" mat-button>
                <span class="c-header-lg">사업자 서비스</span>
                <span aria-hidden="true" class="material-symbols-outlined c-gray mat-icon-size-25">arrow_drop_down</span>
              </button>
              <mat-menu #openHouse="matMenu" xPosition="before">
                <button mat-menu-item routerLink="/info/business-analysis">사업자 권리분석 소개</button>
                <button mat-menu-item routerLink="/info/business-analysis-preview">사업자 권리분석 미리보기</button>
                <button mat-menu-item routerLink="/house/open">오픈부동산 알림신청</button>
                <button [queryParams]="{type: 'OPEN_HOUSE'}" mat-menu-item routerLink="/house/register">오픈부동산 등록
                </button>
                <button mat-menu-item routerLink="/house/extends">서비스 일괄 연장</button>
                <button mat-menu-item routerLink="/coupon">쿠폰 구입</button>
                <button mat-menu-item routerLink="/info/open-house">서비스 안내</button>
                <button mat-menu-item routerLink="/info/api">체크팀 API</button>
              </mat-menu>

              <button fxHide mat-button class="m-t-m2 c-header-lg">
                <a [queryParams]="{type: 'UPDATE'}" routerLink="/info/notice">
                  <span class="p-r-3">업데이트</span>
                  @if (countUpdates && countUpdates > 0) {
                    <span class="badge-notice bg-mint-darker">{{ countUpdates }}</span>
                  }
                </a>
              </button>

              <button [matMenuTriggerFor]="serviceMenu" mat-button>
                <span class="c-header-lg">고객지원</span>
                <span aria-hidden="true" class="material-symbols-outlined mat-icon-size-25">arrow_drop_down</span>
              </button>
              <mat-menu #serviceMenu="matMenu" xPosition="before">
                @if (devMode) {
                  <button mat-menu-item routerLink="/info/guide-boards">활용가이드</button>
                }
                <button [queryParams]="{type: 'NOTICE'}" mat-menu-item routerLink="/info/notice">
                  공지사항
                  @if (countNotices && countNotices > 0) {
                    <span class="badge-notice">{{ countNotices }}</span>
                  }
                </button>
                <button [queryParams]="{type: 'EVENT'}" mat-menu-item routerLink="/info/events">이벤트</button>
                <button mat-menu-item routerLink="/info/faq">자주하는 질문</button>
                <button [queryParams]="{type: 'INQUIRE'}" mat-menu-item routerLink="/inquire">1:1 문의</button>
                <button [queryParams]="{type: 'ERROR'}" mat-menu-item routerLink="/inquire">오류신고</button>
                <button [queryParams]="{type: 'SUGGEST'}" mat-menu-item routerLink="/inquire">기능요청</button>
                <button mat-menu-item routerLink="/info/company">회사소개</button>
              </mat-menu>

              <a class="header-guide-menu" href="/guides/index.html" mat-button>
                <span class="c-header-lg">부동산 가이드</span>
              </a>

            </div>
          }
        </div>

        <div fxLayout="row" fxLayoutAlign="end center">
          @if (!mobile()) {
            <button aria-label="마이 부동산" class="header-action-button header-my-real-estate p-t-5" mat-button routerLink="/my-real-estate">
              <span class="header-action-icon">
                <lord-icon
                  src="assets/img/lordicon/location-user-outline.json"
                  trigger="hover"
                  state="hover-pinch"
                  colors="primary:#242424"
                  style="width:27px;height:27px">
                </lord-icon>
              </span>
            </button>
          }
          @if (login()) {
            <div fxLayout="row">

              <button aria-label="쿠폰함" class="header-action-button p-t-5" fxHide fxShow.gt-xs mat-button routerLink="/home/coupon">
                <span class="header-action-icon">
                  <lord-icon
                    src="assets/img/lordicon/ticket-perforated.json"
                    trigger="hover"
                    state="hover-pinch"
                    colors="primary:#242424"
                    style="width:27px;height:27px">
                  </lord-icon>
                  @if (countCoupons) {
                    <span class="header-action-count-badge">{{ countCoupons }}</span>
                  }
                </span>
              </button>

              <button mat-button routerLink="/notification" ngClass.xs="m-r-m10" class="header-action-button p-t-5">
                <span class="header-action-icon">
                  <lord-icon
                    src="https://cdn.lordicon.com/ahxaipjb.json"
                    trigger="hover"
                    colors="primary:#242424"
                    style="width:27px;height:27px">
                  </lord-icon>
                  @if (countNotifications) {
                    <span class="header-action-count-badge">{{ countNotifications }}</span>
                  }
                </span>
              </button>

              <div>
                <button aria-label="회원 설정" mat-button [matMenuTriggerFor]="myHome" ngClass.xs="m-r-m15" class="header-action-button p-t-5">
                  <lord-icon
                    src="https://cdn.lordicon.com/bushiqea.json"
                    trigger="hover"
                    colors="primary:#242424"
                    style="width:27px;height:27px">
                  </lord-icon>
                </button>

                <mat-menu #myHome="matMenu" xPosition="before">
<!--                  <button mat-menu-item routerLink="/my-real-estate">마이 부동산</button>-->
                  <button mat-menu-item routerLink="/home">마이페이지</button>
                  <button mat-menu-item routerLink="/home/info">회원정보변경</button>
                  <button mat-menu-item (click)="openRightsHolderNames()">권리자 이름 설정</button>
                  <button mat-menu-item routerLink="/home/sns">SNS 로그인 설정</button>
                  @if (devMode) {
                    <button mat-menu-item routerLink="/home/payment-method">자동결제 설정</button>
                  }
                  <button mat-menu-item routerLink="/home/purchase">결제내역</button>
                  <button mat-menu-item routerLink="/home/coupon">쿠폰함</button>
                  <button mat-menu-item (click)="clickLogout()">로그아웃</button>
                </mat-menu>
              </div>
            </div>

          } @else {
            <div fxLayout="row" fxLayoutGap="10px" fxShow.gt-xs fxHide>
              <button ngClass.gt-xs="bg-gray-light hover-primary c-header-lg" mat-flat-button
                      ngClass.xs="f-11 bg-gray-light f-w-700" routerLink="/join">회원가입
              </button>
              <button (click)="clickLogin()" ngClass.gt-xs="bg-accent hover-primary c-header-lg"
                      ngClass.xs="f-11 bg-black f-w-700" mat-flat-button>
                로그인
              </button>
            </div>
            <button fxShow fxHide.gt-xs (click)="clickLogin()" aria-label="로그인" mat-button class="mobile-login-button m-r-m15">
              <span aria-hidden="true" class="material-symbols-outlined img-size-30 f-w-700">account_circle</span>
            </button>

          }
        </div>

      </mat-toolbar>
    </div>
  </header>
</div>
